import { Component, forwardRef } from '@angular/core';
import { BaseFormComponent } from '../../global/BaseFormComponent';
import { FormGroup, FormControl, Validators, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { WhiteSpacesValidator } from 'src/app/validators/whitespaces-validator';
import { WordsValidator } from 'src/app/validators/words-validator';
import { DescriptionGuidelinesComponent } from 'src/app/pages/description-guidelines/description-guidelines.component';

@Component({
  standalone: false,
  selector: 'app-description-form',
  templateUrl: './description-form.component.html',
  styleUrls: ['./description-form.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DescriptionFormComponent),
    multi: true
  }]
})
export class DescriptionFormComponent extends BaseFormComponent {

  constructor(private whiteSpacesValidator: WhiteSpacesValidator, private wordsValidator: WordsValidator, public dialog: MatDialog) {
    super();

    this.form = new FormGroup({
      teaser: new FormControl('', [Validators.required, Validators.minLength(100), Validators.maxLength(250) , this.whiteSpacesValidator.validate()]),
      metadescription: new FormControl('', [Validators.minLength(25), Validators.maxLength(140) , this.whiteSpacesValidator.validate()]),
      description: new FormControl('', [Validators.required, Validators.minLength(100), Validators.maxLength(750),this.whiteSpacesValidator.validate()]),
      audience: new FormControl('', [Validators.required])
    });

    this.onValueChanged(p => {
      this.setValues(p.teaser as string, p.description as string, p.metadescription as string, p.audience as string);
    });

    this.form.valueChanges.subscribe(values => {
      this.value.teaser = values.teaser;
      this.value.description = values.description;
      this.value.metadescription = values.metadescription;
      this.value.audience = values.audience;
    });
  }

  setValues(teaser: string, description: string, metadescription: string, audience: string): void {
    this.form.get('teaser').setValue(teaser);
    this.form.get('description').setValue(description);
    this.form.get('audience').setValue(audience);
    this.form.get('metadescription').setValue(metadescription);
  }

  openDescriptionGuidelines(){
    const dialogRef = this.dialog.open(DescriptionGuidelinesComponent);
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog closed: ${result}`);
    });
  }
}